var klaviyo = klaviyo || [];
      klaviyo.init({
        account: 'N5CuHx',
        list: 'Q6K855',
        platform: 'shopify',
      });
      klaviyo.enable('backinstock', {
        trigger: {
          product_page_text: 'NOTIFY ME WHEN AVAILABLE',
          product_page_class: 'button  ajax-submit action_button button--add-to-cart',
          product_page_text_align: 'center',
          product_page_margin: '5px',
          replace_anchor: false,
        },
        modal: {
          headline: '{product_name}',
          body_content: 'REGISTER TO RECEIVE A NOTIFICATION WHEN THIS ITEM COMES BACK IN STOCK.',
          email_field_label: 'Email',
          button_label: 'NOTIFY ME WHEN AVAILABLE',
          subscription_success_label: "YOU'RE IN! WE'LL LET YOU KNOW WHEN IT'S BACK.",
          footer_content: '',
          additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
          drop_background_color: '#000',
          background_color: '#fff',
          text_color: '#222',
          button_text_color: '#ffffff',
          button_background_color: '#000000',
          close_button_color: '#ccc',
          error_background_color: '#fcd6d7',
          error_text_color: '#C72E2F',
          success_background_color: '#d3efcd',
          success_text_color: '#1B9500',
        },
      });